
import { http } from "../../../shared/api/http";
import { Order } from "../models/types";

export async function ordersPickupDelivery(): Promise<Order[]> {
  const res = await http.get(`/waiter/orders/pickup-delivery`);
  return res.data;
}